import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BreadcrumbType } from "types";
import { setBreadCrumbs as updateBreadcrumbs } from "store/app/app.slice";
import { translate } from "utils";
import { DashboardOutlined } from "@ant-design/icons";
import { selectLang } from "store/lang/langSlice";

export default function useBreadcrumb() {
	const dispatch = useDispatch();
	const lang = useSelector(selectLang);

	const dashboardBreadcrumb = useMemo(() => ({
		label: translate("Dashboard"),
		path: "/dashboard",
		icon: <DashboardOutlined />,
	}), [lang]);

	useEffect(
		() => () => {
			dispatch(updateBreadcrumbs([]));
		},
		[],
	);

	const setBreadCrumbs = (breadcrumbs: BreadcrumbType[]) => {
		dispatch(updateBreadcrumbs([dashboardBreadcrumb, ...breadcrumbs]));
	};

	return { setBreadCrumbs };
}
